import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import { useEffect } from "react";
import { Button, DateTimePicker, Icon } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { MdPunchClock } from "react-icons/md";
//#region src/modules/FormBuilder/components/Fields/DateTime/Form.tsx
var DateTimeFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	useEffect(() => {
		if (!config.options.noDefaultValue || config.options.disabledStaticValue) {
			if (valuesByFieldId[config.id] === void 0) fieldValueChanged(config.id, (/* @__PURE__ */ new Date()).toISOString());
		}
	}, [config, valuesByFieldId[config.id]]);
	return /* @__PURE__ */ jsx(DateTimePicker, {
		error: errorsByFieldId[config.id],
		disabled: config.options.disabledStaticValue,
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		label: /* @__PURE__ */ jsx(Fragment$1, { children: config.options.label || config.options.formLabel }),
		noInitialValue: config.options.noDefaultValue,
		mode: config.options.mode,
		onChangeValue: (val) => {
			fieldValueChanged(config.id, val);
		},
		value: valuesByFieldId[config.id],
		name: config.name,
		subText: /* @__PURE__ */ jsxs(Fragment$1, { children: [!valuesByFieldId[config.id] && config.options.noDefaultValue && /* @__PURE__ */ jsxs(Button, {
			className: "mr-xs",
			onClick: () => {
				fieldValueChanged(config.id, (/* @__PURE__ */ new Date()).toISOString());
			},
			size: "xs",
			variant: "main",
			children: [
				/* @__PURE__ */ jsx(Icon, {
					Icon: MdPunchClock,
					size: "xs"
				}),
				" Set",
				" ",
				config.options.mode === "date" ? "Date" : config.options.mode === "time" ? "Time" : "Date/Time",
				" ",
				"Now"
			]
		}), config.options.subText] })
	});
};
//#endregion
export { DateTimeFieldForm };

//# sourceMappingURL=Form.js.map